import React, { useRef } from 'react'
import { useGetVendorAudienceDetails } from '../../../api/dealership/customers/audiences/useGetVendorAudienceDetails'
import AudienceMetricCard from './AudienceMetricCard'
import { ReactComponent as AudiencePeople } from '../../../images/icons/audience_people.svg'
import { AnimatePresence, motion, MotionConfig } from 'framer-motion'
import { formatNumber } from '../../../lib/utils/formatNumber'

type Props = {
  audience_id: any
  vendor_id: number
}

const TradeDeskVendorAudienceDetails = ({
  audience_id,
  vendor_id,
}: Props): JSX.Element => {
  const { data: vendorAudience, isLoading } = useGetVendorAudienceDetails({
    audience_id: audience_id,
    filters: {
      vendor_id: vendor_id,
    },
  })

  return (
    <>
      {vendorAudience?.vendor_audience_details?.activeIds && (
        <AnimatePresence>
          <motion.div
            className={'grid grid-cols-3 gap-5'}
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}>
            <AudienceMetricCard
              title={'Active Ids'}
              value={`${formatNumber(
                vendorAudience?.vendor_audience_details?.activeIds.total ?? 0,
              )}`}
              isLoading={isLoading}>
              <AudienceMetricCard.Icon>
                <div className={'p-3 bg-primary-persian-blue/5 rounded-full'}>
                  <AudiencePeople className={'stroke-primary-persian-blue'} />
                </div>
              </AudienceMetricCard.Icon>
            </AudienceMetricCard>
            <AudienceMetricCard
              title={'People'}
              value={formatNumber(
                vendorAudience?.vendor_audience_details.personsCount ?? 0,
              )}
              isLoading={isLoading}>
              <AudienceMetricCard.Icon>
                <div className={'p-3 bg-primary-persian-blue/5 rounded-full'}>
                  <AudiencePeople className={'stroke-primary-persian-blue'} />
                </div>
              </AudienceMetricCard.Icon>
            </AudienceMetricCard>
            <AudienceMetricCard
              title={'Households'}
              value={formatNumber(
                vendorAudience?.vendor_audience_details.householdCount ?? 0,
              )}
              isLoading={isLoading}>
              <AudienceMetricCard.Icon>
                <div className={'p-3 bg-primary-persian-blue/5 rounded-full'}>
                  <AudiencePeople className={'stroke-primary-persian-blue'} />
                </div>
              </AudienceMetricCard.Icon>
            </AudienceMetricCard>
          </motion.div>
        </AnimatePresence>
      )}
    </>
  )
}

export default TradeDeskVendorAudienceDetails
